import { z } from 'zod'
import { Model } from './architecture'

export const PathValidation = z.object({
  value: z.string({ required_error: '[Path] value is required' }),
})

export class Path extends Model {
  static create({ value }: z.infer<typeof PathValidation>) {
    PathValidation.parse({ value })
    return new Path(value)
  }

  constructor(private readonly _value: string) {
    super()
  }

  get value() { return this._value } // prettier-ignore

  toJSON() {
    return { value: this.value }
  }
}
